import React from "react";
import { Grid, Header } from "semantic-ui-react";
import FileUploadButton from "../../fileUploadButton";

const PassportFideliteImages = ({ obj, onChange }) => {
  return (
    <div>
      <Grid columns={3}>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Header as="h3">Header</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <FileUploadButton id="header_desktop" label="Header (desktop)" image={obj.header_desktop} onChange={onChange} />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton id="header_mobile" label="Header (mobile)" image={obj.header_mobile} onChange={onChange} />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton id="passportfidelite_attachment" label="Passport Pièce Jointe" image={obj.passportfidelite_attachment} onChange={onChange} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default PassportFideliteImages;



// WEBPACK FOOTER //
// ./src/components/form/passportfidelite/images.js